import { useRef } from "react"
import { 
    AlertDialog, 
    AlertDialogBody, 
    AlertDialogCloseButton, 
    AlertDialogContent, 
    AlertDialogFooter, 
    AlertDialogHeader, 
    AlertDialogOverlay, 
    Button, 
    HStack 
} from "@chakra-ui/react"
import type { DialogProps } from "./types"

const Dialog = ({isOpen,message, title, onClose, onConfirm}:DialogProps) => {
    const cancelButtonRef = useRef<HTMLButtonElement>(null)
    const onPressConfirm = async() => {
        await onConfirm()
        onClose()
    }

    return (
        <AlertDialog 
            isOpen={isOpen} 
            leastDestructiveRef={cancelButtonRef} 
            returnFocusOnClose={true} 
            closeOnOverlayClick={false}
            onClose={onClose} 
        >
            <AlertDialogOverlay/>
            <AlertDialogContent>
                <AlertDialogCloseButton/>
                <AlertDialogHeader>{title}</AlertDialogHeader>
                <AlertDialogBody>{message}</AlertDialogBody>
                <AlertDialogFooter>
                    <HStack>
                        <Button ref={cancelButtonRef} colorScheme="gray" onClick={onClose}>Cancelar</Button>
                        <Button colorScheme="blue" onClick={onPressConfirm}>Aceptar</Button>
                    </HStack>
                </AlertDialogFooter>
            </AlertDialogContent>
        </AlertDialog>
    )
}

export default Dialog;